import React from 'react';
import { connect } from "react-redux";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { withRouter } from "react-router-dom";
import LoginPage from '../loginPage';

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthorized: false,
            blocking: false,
        };
    }
    componentWillMount() {
        // console.log("container mount : ")
        // console.log(this.props.loggedInUser);

    }
    componentWillReceiveProps(nextProps) {
        // console.log("nextProps");
        // console.log(nextProps);
        this.setState({ blocking: nextProps.blocking.blocking });
    }
    render() {
        // console.log("Container : ");
        // console.log(this.props.loggedInUser);
        const { children } = this.props;
        const childrenWithProps = React.Children.map(children, (child, i) => {
            // console.log(child.props.path);
            return child;
        });
        return (
            <div>
               {this.props.loggedInUser === undefined ? <LoginPage />:null } 
                 <div className="content">
                        {childrenWithProps}
                    </div>
                </div>
    );
}
}
const mapStateToProps = (state) => {
    return {
        blocking: state.loginReducer,
        loggedInUser: state.loginReducer.loggedInUser
    }
}
export default withRouter(connect(mapStateToProps)(Container));